import { ReactElement, ReactFragment, ReactNode } from 'react';

// Components.

// Styles.
import styles from './CertMasterEntryLink.module.scss';
import { useTranslation } from 'react-i18next';
import {
  ArrowRightToBracketIcon,
  CertMasterPlatformRole,
  Vendors,
} from '@comptia-sso/core';
import { useCertMasterPlatformHighestRole } from '../../hooks/identity/useCertMasterPlatformHighestRole';
import { useProfile, useRedirectToVendor } from '../../hooks';
import { CertMasterActions } from '../../hooks/vendor/useRedirectToCertMaster';

export const CertMasterEntryLink = (): ReactElement => {
  const { t } = useTranslation();
  const [profile] = useProfile();

  const [response] = useCertMasterPlatformHighestRole(profile?.id);

  const [redirect] = useRedirectToVendor();

  const action = getActionByRole(response?.role);

  if (!response?.role || response?.role === CertMasterPlatformRole.None) {
    return <></>;
  }

  return (
    <a
      className={styles.certMasterLink}
      href="#"
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        redirect(Vendors.CertMaster, {
          certMasterAction: action,
          classroom: response.campusId,
        });
        return false;
      }}
    >
      {t(`CertMasterEntry.${getLocalizationKeyByRole(response?.role)}`)}
      <ArrowRightToBracketIcon />
    </a>
  );
};

function getActionByRole(role: CertMasterPlatformRole): CertMasterActions {
  switch (role) {
    case CertMasterPlatformRole.Employee:
      return CertMasterActions.EmployeeTools;
    case CertMasterPlatformRole.Administrator:
    case CertMasterPlatformRole.Instructor:
      return CertMasterActions.MySchools;
    default:
      return CertMasterActions.MyCourses;
  }
}

function getLocalizationKeyByRole(role: CertMasterPlatformRole): string {
  switch (role) {
    case CertMasterPlatformRole.Employee:
      return 'EmployeeTools';
    case CertMasterPlatformRole.Administrator:
      return 'InstitutionManagement';
    case CertMasterPlatformRole.Instructor:
      return 'ClassManagement';
    default:
      return 'CoursewareHome';
  }
}
